import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import {
  getEDUCATIONGROUPMASTERAction,
  getDEGREEMASTERAction,
  getUNIVERSITYMASTERAction,
  getCOLLEGEMASTERAction,
  getSPECIALIZATIONMASTERAction,
} from "store/masters";
import { getEducationAction, setEducationAction } from "store/userWalkthrough";
import { ChevronLeft, ChevronDown } from "react-feather";
import trash from "views/profile/img/delete-2.svg";
import edit from "views/profile/img/edit.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import kyc from "views/profile/img/kyc/kyc.png";
import moment from "moment";
class Education extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddEducation: true,
      EducationGroup: "13",
      EducationBoardName: "",
      EducationType: "",
      EducationName: "",
      EduRID: "",
      GroupText: "",
      EducationID: "",
      CollegeName: "",
      SpecializationID: "",
      Specialization: "",
      InstituteID: "",
      InstituteName: "",
      UniversityID: "",
      UniversityName: "",
      Percentage: "",
      Month: "",
      Year: "",
      IsHighestEducation: "",
      MonthTo: "",
      YearTo: "",
      Grp2Month: "",
      Grp2Year: "",
      HasAttempts: "",
      OptionsUniversity: [],
      OptionsUniversityValue: "",
      OptionsCollege: [],
      OptionsCollegeValue: "",
      OptionsDegree: [],
      OptionsDegreeValue: "",
      optionSpecial: [],
      optionSpecialValue: "",
    };
  }
  getMonthBasedOnString(val) {
    debugger;
    switch (val) {
      case "January":
        return "1";
        break;
      case "February":
        return "2";
        break;
      case "March":
        return "3";
        break;
      case "April":
        return "4";
        break;
      case "May":
        return "5";
        break;
      case "June":
        return "6";
        break;
      case "July":
        return "7";
        break;
      case "August":
        return "8";
        break;
      case "September":
        return "9";
        break;
      case "October":
        return "10";
        break;
      case "November":
        return "11";
        break;
      case "December":
        return "12";
        break;
      default:
        return "13";
    }
  }
  hasValueInArray(JSON, Search) {
    debugger;
    var hasMatch = false;

    for (var index = 0; index < JSON.length; ++index) {
      var animal = JSON[index];

      if (animal.RID == Search) {
        hasMatch = true;
        return hasMatch;
        break;
      }
    }
  }
  async componentDidMount() {
    await this.props.getEDUCATIONGROUPMASTERAction();
    await this.props.getUNIVERSITYMASTERAction();
    await this.props.getCOLLEGEMASTERAction();
    await this.props.getSPECIALIZATIONMASTERAction();
    let optionsUniversity = this.props.UNIVERSITYMASTER.Data.map((el) => ({
      label: el.Title,
      value: el.Value,
    }));
    let optionsCollege = this.props.COLLEGEMASTER.Data.map((el) => ({
      label: el.Title,
      value: el.Value,
    }));
    let optionsSPECIAL = this.props.SPECIALIZATION.Data.map((el) => ({
      label: el.Title,
      value: el.Value,
    }));

    // let optionsDegree1= this.props.DEGREEMASTER.Data.map(
    //   (x) =>
    //   {(
    //       x.RID == 2136
    //       ||
    //       x.RID == 478
    //       ||
    //       x.RID == 1952
    //       ||
    //       x.RID == 356
    //       ||
    //       x.RID == 439
    //       ||
    //       x.RID == 222
    //       ||
    //       x.RID == 1968
    //       ||
    //       x.RID == 2183
    //       ||
    //       x.RID == 353
    //       ||
    //       x.RID == 2167
    //       ||
    //       x.RID == 295
    //       ||
    //       x.RID == 225
    //       ||
    //       x.RID == 3075
    //       ||
    //       x.RID == 286
    //       ||

    //       x.RID == 1939
    //       ||
    //       x.RID == 441
    //       ||
    //       x.RID == 2050
    //       ||

    //       x.RID == 2125
    //       ||
    //       x.RID == 432
    //       ||
    //        x.RID == 2139 ||
    //        x.RID == 1950 ||
    //        x.RID == 2149 ||
    //        x.RID == 1951 ||
    //        x.RID == 414 ||
    //        x.RID == 1941 ||
    //        x.RID == 229 ||
    //        x.RID == 2101 ||
    //        x.RID == 436 ||
    //        x.RID == 425 ||
    //        x.RID == 2153 ||
    //        x.RID == 2038 ||
    //        x.RID == 206 ||
    //        x.RID == 256 ||
    //        x.RID == 2128 ||
    //        x.RID == 215 ||
    //        x.RID == 1877 ||
    //        x.RID == 1838||
    //        x.RID == 1787||
    //        x.RID == 1827||
    //        x.RID == 78||
    //        x.RID == 161||
    //        x.RID == 1873||
    //        x.RID == 1789||
    //        x.RID == 1793||
    //        x.RID == 1921||
    //        x.RID == 1736||
    //        x.RID == 154||
    //        x.RID == 188||
    //        x.RID == 1814||
    //        x.RID == 1900||
    //        x.RID == 8||
    //        x.RID == 1903||
    //        x.RID == 1905||
    //        x.RID == 71||
    //        x.RID == 1906||
    //        x.RID == 1908||
    //        x.RID == 1910||
    //        x.RID == 1936||
    //        x.RID == 102||
    //        x.RID == 1914||
    //        x.RID == 1797||
    //        x.RID == 140||
    //        x.RID == 183||
    //        x.RID == 142||
    //        x.RID == 98||
    //        x.RID == 1831||
    //        x.RID == 184||
    //        x.RID == 105||
    //        x.RID == 86||
    //        x.RID == 137||
    //        x.RID == 200||
    //        x.RID == 1933||
    //        x.RID == 1875||
    //        x.RID == 155||
    //        x.RID == 1800||
    //        x.RID == 1845
    //        ||
    //        x.RID == 147||
    //        x.RID == 1731||
    //        x.RID == 1879||
    //        x.RID == 23
    //        ?

    //   {label: x.Title,
    //     value: x.RID}

    //     :"")})
    this.setState({
      OptionsUniversity: optionsUniversity,
      OptionsCollege: optionsCollege,
      optionSpecial: optionsSPECIAL,
    });
  }
  async EducationGroupChange(value) {
    this.setState({ EducationGroup: value });
    if (value == 7) {
      this.setState({ UniversityID: 176 });
    }
    await this.props.getDEGREEMASTERAction(value);
    let optionsDegree = this.props.DEGREEMASTER.Data.map((el) => ({
      label: el.Title,
      value: el.RID,
    }));

    this.setState({ OptionsDegree: optionsDegree });
  }
  async SaveAcademicDetails(e) {
    e.preventDefault();
    if (this.state.EducationGroup == 1 && this.state.UniversityID == "") {
      // University *
      alert("University Required");
      return false;
    }
    if (this.state.EducationGroup == 1 && this.state.InstituteID === "") {
      alert("College Required");
      return false;
    }
    if (this.state.EducationGroup == 1 && this.state.EducationID == "") {
      alert("Degree Required");
      return false;
    }
    if (this.state.EducationGroup == 1 && this.state.SpecializationID == "") {
      alert("Specialization Required");
      return false;
    }

    if (this.state.EducationGroup == 8 && this.state.UniversityID == "") {
      // University *
      alert("University Required");
      return false;
    }
    if (this.state.EducationGroup == 8 && this.state.InstituteID === "") {
      alert("College Required");
      return false;
    }
    if (this.state.EducationGroup == 8 && this.state.EducationID == "") {
      alert("Degree Required");
      return false;
    }
    if (this.state.EducationGroup == 8 && this.state.SpecializationID == "") {
      alert("Specialization Required");
      return false;
    }
    let payload = [
      {
        EducationType: this.state.EducationType,
        EducationName:
          this.state.EducationGroup == 13
            ? "10th"
            : this.state.EducationGroup == 14
            ? "12th"
            : this.state.EducationName,
        EduRID: this.state.EduRID,
        GroupText: this.state.GroupText,
        EducationID:
          this.state.EducationGroup == 13
            ? 41
            : this.state.EducationGroup == 14
            ? 42
            : this.state.EducationGroup == 7
            ? 12
            : this.state.EducationGroup == 11
            ? 1461
            : this.state.EducationID,
        CollegeName: this.state.CollegeName,
        SpecializationID: this.state.SpecializationID,
        Specialization: this.state.Specialization,
        InstituteID: this.state.InstituteID,
        InstituteName: this.state.InstituteName,
        UniversityID: this.state.UniversityID,
        UniversityName:
          this.state.EducationGroup == 13
            ? this.state.EducationBoardName
            : this.state.EducationGroup == 14
            ? this.state.EducationBoardName
            : this.state.UniversityName,
        Percentage: this.state.Percentage,
        Month: this.state.Month ? this.state.Month.getMonth() + 1 : "",
        Year: this.state.Year ? this.state.Year.getFullYear() : "",
        IsHighestEducation: this.state.IsHighestEducation,
        MonthTo: this.state.MonthTo,
        YearTo: this.state.YearTo,
        Grp2Month:
          this.state.HasAttempts == 0
            ? this.state.Month
              ? this.state.Month.getMonth() + 1
              : ""
            : this.state.Grp2Month
            ? this.state.Grp2Month.getMonth() + 1
            : "",
        Grp2Year:
          this.state.HasAttempts == 0
            ? this.state.Year
              ? this.state.Year.getFullYear()
              : ""
            : this.state.Grp2Year
            ? this.state.Grp2Year.getFullYear()
            : "",
        HasAttempts: this.state.HasAttempts,
      },
    ];
    var obj = {
      CandidateNo: this.props.Auth.HCID,
      EducationData: payload,
    };

    let response = await this.props.setEducationAction(obj);

    if (response.ResponseCode == 100) {
      this.setState({ isAddEducation: true });
      this.props.Next(false);
      this.props.getEducationAction(this.props.Auth.HCID);
    }
  }
  async UniversityChange(e) {
    this.setState({ UniversityID: e.value, OptionsUniversityValue: e });
  }
  async CollegeChange(e) {
    this.setState({ InstituteID: e.value, OptionsCollegeValue: e });
  }
  async DegreeChange(e) {
    this.setState({ EducationID: e.value, OptionsDegreeValue: e });
  }
  async SpecializationChange(e) {
    this.setState({ SpecializationID: e.value, optionSpecialValue: e });
  }
  async emptyState() {
    this.props.Next(true);

    this.setState({
      //  isAddEducation: true,
      EducationGroup: "13",
      EducationBoardName: "",
      EducationType: "",
      EducationName: "",
      EduRID: "",
      GroupText: "",
      EducationID: "",
      CollegeName: "",
      SpecializationID: "",
      Specialization: "",
      InstituteID: "",
      InstituteName: "",
      UniversityID: "",
      UniversityName: "",
      Percentage: "",
      Month: "",
      Year: "",
      IsHighestEducation: "",
      MonthTo: "",
      YearTo: "",
      Grp2Month: "",
      Grp2Year: "",
      HasAttempts: "",
      optionSpecialValue: "",
      OptionsDegreeValue: "",
      OptionsCollegeValue: "",
      OptionsUniversityValue: "",
    });
  }

  async emptyStatecancel() {
    this.props.Next(false);

    this.setState({
      //  isAddEducation: true,
      EducationGroup: "13",
      EducationBoardName: "",
      EducationType: "",
      EducationName: "",
      EduRID: "",
      GroupText: "",
      EducationID: "",
      CollegeName: "",
      SpecializationID: "",
      Specialization: "",
      InstituteID: "",
      InstituteName: "",
      UniversityID: "",
      UniversityName: "",
      Percentage: "",
      Month: "",
      Year: "",
      IsHighestEducation: "",
      MonthTo: "",
      YearTo: "",
      Grp2Month: "",
      Grp2Year: "",
      HasAttempts: "",
      optionSpecialValue: "",
      OptionsDegreeValue: "",
      OptionsCollegeValue: "",
      OptionsUniversityValue: "",
    });
  }

  async editEducation(x) {
    this.setState({
      isAddEducation: false,
      EduRID: x.EduRID,
      EducationID: x.EducationID,
      EducationName: x.EducationName,
      EducationType: x.EducationType,
      Percentage: x.Grade,
      GroupText: x.GroupName,
      Grp2Month: x.Grp2Month,
      Grp2Year: x.Grp2Year,
      HasAttempts: x.HasAttempts,
      InstituteID: x.InstituteID,
      InstituteName: x.InstituteName,
      IsHighestEducation: x.IsHighestEducation,
      Month: new Date(this.getMonthBasedOnString(x.MonthOfPassing)),
      MonthTo: x.MonthTO,
      Specialization: x.Specialization,
      SpecializationID: x.SpecializationID,
      UniversityID: x.UniversityID,
      UniversityName: x.UniversityName,
      Year: x.YearOfPassing ? new Date(x.YearOfPassing) : "",
      YearTo: x.YearTo,
      EducationGroup: x.GroupID,
      optionSpecialValue: { label: x.Specialization, value: x.Specialization },
      OptionsCollegeValue: { label: x.InstituteName, value: x.InstituteID },
      OptionsDegreeValue: { label: x.EducationName, value: x.EducationID },
      OptionsUniversityValue: { label: x.Board, value: x.UniversityID },
    });
    if (!x.EducationID == 0 || !x.EducationID == "") {
      if (x.EducationID == 414) {
        this.setState({ EducationGroup: 8 });
      }
      if (x.EducationID == 41) {
        this.setState({ EducationGroup: 13 });
      } else if (x.EducationID == 42) {
        this.setState({ EducationGroup: 14 });
      } else if (x.EducationID == 12) {
        this.setState({ EducationGroup: 7 });
      } else if (x.EducationID == 1461) {
        this.setState({ EducationGroup: 11 });
      } else {
        let Degree = await this.props.getDEGREEMASTERAction(1);
        if (Degree.ResponseCode == 100) {
          if (this.hasValueInArray(Degree.Data, x.EducationID)) {
            this.setState({ EducationGroup: 1 });
            return true;
          }
        }
        let PostDegree = await this.props.getDEGREEMASTERAction(2);
        if (PostDegree.ResponseCode == 100) {
          if (this.hasValueInArray(PostDegree.Data, x.EducationID)) {
            this.setState({ EducationGroup: 2 });
            return true;
          } else {
            alert("Invalid education details, please rectify");
            this.setState({ EducationGroup: 13 });
          }
        }
      }
    }
  }

  ValidateNumber(strNumber) {
    var regExp = new RegExp("^[a-zA-Z]+(s[a-zA-Z]+)?$");
    var isValid = regExp.test(strNumber);
    if (!isValid) {
      this.setState({ Percentage: strNumber });
    }
    // or just: /^\d+$/.test(strNumber);return isValid;
  }

  getMonthName(names) {
    const months = [
      { month: "Jan", value: "0" },
      { month: "Feb", value: "1" },
      { month: "Mar", value: "2" },
      { month: "Apr", value: "3" },
      { month: "May", value: "4" },
      { month: "Jun", value: "5" },
      { month: "July", value: "6" },
      { month: "Aug", value: "7" },
      { month: "Sep", value: "8" },
      { month: "Oct", value: "9" },
      { month: "Nov", value: "10" },
      { month: "Dec", value: "11" },
    ];
    var monthName = names == "" ? "" : names.getMonth();
    let obj = months.find((o) => o.value == monthName);
    return obj == undefined ? "" : obj.month;
  }

  render() {
    const months = [
      { month: "Jan", value: "01" },
      { month: "Feb", value: "02" },
      { month: "Mar", value: "03" },
      { month: "Apr", value: "03" },
      { month: "May", value: "04" },
      { month: "Jun", value: "05" },
      { month: "July", value: "06" },
      { month: "Aug", value: "07" },
      { month: "Sep", value: "08" },
      { month: "Oct", value: "09" },
      { month: "Nov", value: "10" },
      { month: "Dec", value: "11" },
    ];

    const lastDateOfYear = `12/31/${new Date().getFullYear()}`;
    return (
      <card className="rounded-12px lg:w-full md:w-full  bg-white block  mt-2">
        <p className="text-black fsize14 mb-4 font-semibold">
          <span className="text-red">*</span> 10th, 12th and Graduation details
          are mandatory to process your application. Please fill the same
          without fail.
        </p>
        <div className=" md:pb-6 lg:pb-6 pb-2">
          {this.state.isAddEducation && (
            <div>
              <div className="text-right sm:w-full mb-4">
                <button
                  className="btn-outline btn-width-sm"
                  onClick={() => {
                    this.setState({
                      isAddEducation: !this.state.isAddEducation,
                    });
                    this.emptyState();
                  }}
                >
                  ADD EDUCATION
                </button>
              </div>

              <div className="lg:grid md:grid lg:grid-cols-3 md:grid-cols-3 lg:gap-12 md:gap-12 ">
                {this.props.EDUCATIONDETAILS
                  ? this.props.EDUCATIONDETAILS.Data.map((x) => {
                      return (
                        <card className="rounded-sm borderblue-t-5px drop-shadow20 bg-white block px-6 py-4 lg:mb-0 md:mb-0 mb-6 ">
                          <div className="flex justify-between 	">
                            <p className="text-black font-bold fsize16">
                              {x.EducationName}
                            </p>
                            <div className="flex items-center">
                              {/* <img src={trash} alt="trash" className="w-5 h-5 mr-3" /> */}
                              <img
                                src={edit}
                                alt="edit"
                                onClick={(e) => this.editEducation(x)}
                                className="text053C6D w-5 h-5 "
                              />
                            </div>
                          </div>
                          <p className="border707070-t opacity-20 my-4 	"></p>
                          <div>
                            <div className="flex justify-between items-center mb-3">
                              {x.EducationID == 1461 ? (
                                ""
                              ) : (
                                <>
                                  <p className="text4B4B4B fsize14 opacity-70 w-2/5">
                                    {x.EducationID == 42 || x.EducationID == 41
                                      ? "Board"
                                      : "University"}
                                  </p>
                                  <p className="text4B4B4B fsize14 opacity-70 w-1/5 text-center">
                                    :
                                  </p>

                                  <p className="text4B4B4B fsize14 opacity-90 w-2/5">
                                    {x.UniversityName || x.Board}
                                  </p>
                                </>
                              )}{" "}
                            </div>{" "}
                            {x.EducationID == 42 ||
                            x.EducationID == 41 ||
                            x.EducationID == 12 ||
                            x.EducationID == 1461 ? (
                              ""
                            ) : (
                              <div className="flex justify-between items-center mb-3">
                                <p className="text4B4B4B fsize14 opacity-70 w-2/5">
                                  College Name{" "}
                                </p>
                                <p className="text4B4B4B fsize14 opacity-70 w-1/5 text-center">
                                  :
                                </p>

                                <p className="text4B4B4B fsize14 opacity-90 w-2/5">
                                  {x.InstituteName}
                                </p>
                              </div>
                            )}
                            <div className="flex justify-between items-center mb-3">
                              <p className="text4B4B4B fsize14 opacity-70 w-2/5">
                                Degree{" "}
                              </p>
                              <p className="text4B4B4B fsize14 opacity-70 w-1/5 text-center">
                                :
                              </p>

                              <p className="text4B4B4B fsize14 opacity-90 w-2/5">
                                {x.EducationName}
                              </p>
                            </div>
                            {x.EducationID == 42 ||
                            x.EducationID == 41 ||
                            x.EducationID == 12 ||
                            x.EducationID == 1461 ? (
                              ""
                            ) : (
                              <div className="flex justify-between items-center mb-3">
                                <p className="text4B4B4B fsize14 opacity-70 w-2/5">
                                  Specialization{" "}
                                </p>
                                <p className="text4B4B4B fsize14 opacity-70 w-1/5 text-center">
                                  :
                                </p>

                                <p className="text4B4B4B fsize14 opacity-90 w-2/5">
                                  {x.Specialization}
                                </p>
                              </div>
                            )}
                            {x.EducationID == 42 || x.EducationID == 41 ? (
                              ""
                            ) : (
                              <div className="flex justify-between items-center mb-3">
                                <p className="text4B4B4B fsize14 opacity-70 w-2/5">
                                  Type{" "}
                                </p>
                                <p className="text4B4B4B fsize14 opacity-70 w-1/5 text-center">
                                  :
                                </p>

                                <p className="text4B4B4B fsize14 opacity-90 w-2/5">
                                  {x.EducationType == 1
                                    ? "Full Time"
                                    : "Part Time"}
                                </p>
                              </div>
                            )}
                            <div className="flex justify-between items-center mb-3">
                              <p className="text4B4B4B fsize14 opacity-70 w-2/5">
                                Passing Year{" "}
                              </p>
                              <p className="text4B4B4B fsize14 opacity-70 w-1/5 text-center">
                                :
                              </p>

                              <p className="text4B4B4B fsize14 opacity-90 w-2/5">
                                {x.MonthOfPassing + " " + x.YearOfPassing}
                              </p>
                            </div>
                            <div className="flex justify-between items-center mb-3">
                              <p className="text4B4B4B fsize14 opacity-70 w-2/5">
                                Grade / %{" "}
                              </p>
                              <p className="text4B4B4B fsize14 opacity-70 w-1/5 text-center">
                                :
                              </p>

                              <p className="text4B4B4B fsize14 opacity-90 w-2/5">
                                {x.Grade}
                              </p>
                            </div>
                            {!(x.EducationID == 12) ? (
                              ""
                            ) : (
                              <div className="flex justify-between items-center mb-3">
                                <p className="text4B4B4B fsize14 opacity-70 w-2/5">
                                  Group2 Passing year{" "}
                                </p>
                                <p className="text4B4B4B fsize14 opacity-70 w-1/5 text-center">
                                  :
                                </p>

                                <p className="text4B4B4B fsize14 opacity-90 w-2/5">
                                  {x.Grp2Month + " " + x.Grp2Year}
                                </p>
                              </div>
                            )}
                          </div>
                        </card>
                      );
                    })
                  : ""}
              </div>
              {!this.props.EDUCATIONDETAILS ? (
                <card className="rounded-12px  bg-white block lg:p-0 md:p-0 p-4 lg:mt-4 md:mt-4  sm-shadow-none">
                  <div className="">
                    <img
                      src={kyc}
                      alt="kyccomplete"
                      className="w-full h-240px mob-ekyc sm-h190px object-cover"
                    />

                    <div className="flex justify-center md:mt-8 lg:mt-8 mt-4">
                      <p className="text-black line-h30 fsize18 sm-fsize14 mx-auto lg:w-3/4 md:w-3/4 text-center">
                        No education details are present for your profile,
                        please add education details by clicking below.
                      </p>
                    </div>
                    {/* <div class="w-full  flex justify-center w-full mt-10 ">
                      <button
                        className="filled-button w-230px h-47px fsize16 font-semibold rounded-25px "
                        onClick={() => {
                          this.setState({
                            isAddEducation: !this.state.isAddEducation,
                          });
                          this.emptyState();
                        }}
                      >
                        ADD EDUCATION DETAILS
                      </button>
                    </div> */}
                  </div>
                </card>
              ) : (
                ""
              )}
            </div>
          )}

          {!this.state.isAddEducation && (
            <form onSubmit={(e) => this.SaveAcademicDetails(e)}>
              <div className="relative">
                <div>
                  <div
                    className="flex items-center cursor-pointer"
                    onClick={() => {
                      this.setState({
                        isAddEducation: !this.state.isAddEducation,
                      });
                      this.emptyStatecancel();
                    }}
                  >
                    <ChevronLeft className="text053C6D" />
                    <p className="text-black fsize16 pl-2 font-semibold">
                      Add Education{" "}
                    </p>
                  </div>

                  <div className="mt-2 lg:w-11/12 md:w-11/12 w-full lg:pl-6 md:pl-6">
                    <div className="lg:flex md:flex items-center lg:mb-1 md:mb-1">
                      <div class="form-group pt-4 modal-form-cs lg:w-1/2 md:w-1/2 w-full lg:pr-4 md:pr-4">
                        <label for="">
                          Select Education <span className="text-red">*</span>
                        </label>
                        <div class="relative w-full right-0 rail-select">
                          <div class="select-side">
                            {/* <i class="glyphicon glyphicon-menu-down blue"></i> */}
                            <ChevronDown className="text053C6D" />
                          </div>
                          <select
                            required
                            className="select-dropdown-c fsize15"
                            value={this.state.EducationGroup}
                            onChange={(e) => {
                              this.EducationGroupChange(e.target.value);
                              // this.handleChange(e, "EducationGroup")
                            }}
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            {this.props.EDUCATIONGROUP
                              ? this.props.EDUCATIONGROUP.Data
                                ? this.props.EDUCATIONGROUP.Data.map((x) => {
                                    return (
                                      <option value={x.Value}>{x.Title}</option>
                                    );
                                  })
                                : ""
                              : ""}
                          </select>
                        </div>
                      </div>
                      {this.state.EducationGroup == 13 ||
                      this.state.EducationGroup == 14 ? (
                        <div class="form-group pt-4 modal-form-cs lg:w-1/2 md:w-1/2 w-full lg:pl-4 md:pl-4">
                          <label for="">
                            Name of Board <span className="text-red">*</span>
                          </label>
                          <input
                            required
                            maxLength={50}
                            type="text"
                            placeholder="Board Name"
                            className="fsize16"
                            value={this.state.EducationBoardName}
                            onChange={(e) => {
                              // this.handleChange(e, "EducationBoardName")
                              this.setState({
                                EducationBoardName: e.target.value.replace(
                                  /[^\w\s]/gi,
                                  ""
                                ),
                              });
                            }}
                          />
                          {/* <span style={{ color: "red" }}>{this.state.errors["EducationBoardName"]}</span> */}
                        </div>
                      ) : (
                        ""
                      )}
                      {this.state.EducationGroup == 1 ||
                      this.state.EducationGroup == 8 ||
                      this.state.EducationGroup == 7 ? (
                        <div class="form-group pt-4 modal-form-cs lg:w-1/2 md:w-1/2 w-full lg:pl-4 md:pl-4 ">
                          <label for="">
                            University <span className="text-red">*</span>
                          </label>
                          <div class="relative w-full right-0 rail-select">
                            <div class="select-side">
                              {/* <i class="glyphicon glyphicon-menu-down blue"></i> */}
                              <ChevronDown className="text053C6D" />
                            </div>
                            {/* <select
                              required
                              className="select-dropdown-c fsize15"
                              value={this.state.UniversityID}
                              onChange={(e) => this.UniversityChange(e)}
                            > */}
                            <Select
                              options={this.state.OptionsUniversity}
                              className="select-dropdown-c fsize15 select-search-ht"
                              value={this.state.OptionsUniversityValue}
                              // defaultValue={this.state.selectedCountryPermanent}
                              onChange={(e) => this.UniversityChange(e)}
                            ></Select>
                            {/* <option value="" disabled>
                                Select
                              </option>
                              {this.props.UNIVERSITYMASTER
                                ? this.props.UNIVERSITYMASTER.Data
                                  ? this.props.UNIVERSITYMASTER.Data.map(
                                      (x) => {
                                        return (
                                          <option value={x.Value}>
                                            {x.Title}
                                          </option>
                                        );
                                      }
                                    )
                                  : ""
                                : ""}
                            </select> */}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {this.state.EducationGroup == 1 ||
                    this.state.EducationGroup == 8 ? (
                      <div className="lg:flex md:flex items-center">
                        <div class="form-group modal-form-cs pt-4  lg:w-1/2 md:w-1/2 w-full  lg:pr-4 md:pr-4 ">
                          <label for="">
                            College Name <span className="text-red">*</span>
                          </label>
                          <div class="relative w-full right-0 rail-select">
                            <div class="select-side">
                              {/* <i class="glyphicon glyphicon-menu-down blue"></i> */}
                              <ChevronDown className="text053C6D" />
                            </div>
                            <Select
                              options={this.state.OptionsCollege}
                              className="select-dropdown-c fsize15 select-search-ht"
                              value={this.state.OptionsCollegeValue}
                              // defaultValue={this.state.selectedCountryPermanent}
                              onChange={(e) => this.CollegeChange(e)}
                            ></Select>
                            {/* <select
                              required
                              className="select-dropdown-c fsize15"
                              value={this.state.InstituteID}
                              onChange={(e) => this.CollegeChange(e)}
                            >
                              <option value="" disabled>
                                Select
                              </option>
                              {this.props.COLLEGEMASTER
                                ? this.props.COLLEGEMASTER.Data
                                  ? this.props.COLLEGEMASTER.Data.map((x) => {
                                      return (
                                        <option value={x.Value}>
                                          {x.Title}
                                        </option>
                                      );
                                    })
                                  : ""
                                : ""}
                            </select> */}
                          </div>
                        </div>

                        <div class="pt-4  lg:w-1/2 md:w-1/2 w-full lg:pl-4 md:pl-4">
                          <div className="lg:flex md:flex items-center">
                            <div className=" form-group modal-form-cs lg:w-1/2 md:w-1/2 w-full lg:pr-4 md:pr-4">
                              <label for="">
                                Name of Degree{" "}
                                <span className="text-red">*</span>
                              </label>
                              <div class="relative w-full right-0 rail-select">
                                <div class="select-side">
                                  {/* <i class="glyphicon glyphicon-menu-down blue"></i> */}
                                  <ChevronDown className="text053C6D" />
                                </div>

                                <Select
                                  options={
                                    this.state.OptionsDegree
                                    // .map((x) =>

                                    //     x.value == 2136? x :""
                                    //      )
                                  }
                                  className="select-dropdown-c fsize15 select-search-ht"
                                  value={this.state.OptionsDegreeValue}
                                  // defaultValue={this.state.selectedCountryPermanent}
                                  onChange={(e) => this.DegreeChange(e)}
                                ></Select>
                                {/* <select
                                  required
                                  className="select-dropdown-c fsize15"
                                  value={this.state.EducationID || ""}
                                  onChange={(e) => this.DegreeChange(e)}
                                >
                                  <option value="" disabled>
                                    Select
                                  </option> */}

                                {/* {this.props.DEGREEMASTER
                                  ? this.props.DEGREEMASTER.Data
                                    ? this.props.DEGREEMASTER.Data.map((x) => {
                                        return (
                                          <option value={x.RID}>
                                            {x.Title}
                                          </option>
                                        );
                                      })
                                    : ""
                                  : ""} */}

                                {/* {this.props.DEGREEMASTER
                                    ? this.props.DEGREEMASTER.Data
                                      ? this.props.DEGREEMASTER.Data.map(
                                          (x) => 
                                          {
                                            return (
                                              x.RID == 2136
                                              ||
                                              x.RID == 478
                                              ||
                                              x.RID == 1952
                                              ||
                                              x.RID == 356
                                              ||
                                              x.RID == 439
                                              ||
                                              x.RID == 222
                                              ||
                                              x.RID == 1968
                                              ||
                                              x.RID == 2183
                                              ||
                                              x.RID == 353
                                              ||
                                              x.RID == 2167
                                              ||
                                              x.RID == 295
                                              ||
                                              x.RID == 225
                                              ||
                                              x.RID == 3075
                                              ||
                                              x.RID == 286
                                              ||
                                          
                                              x.RID == 1939
                                              ||
                                              x.RID == 441 
                                              ||
                                              x.RID == 2050 
                                              ||
                                            
                                              x.RID == 2125 
                                              ||
                                              x.RID == 432 
                                              || 
                                               x.RID == 2139 || 
                                               x.RID == 1950 || 
                                               x.RID == 2149 ||  
                                               x.RID == 1951 ||  
                                               x.RID == 414 ||  
                                               x.RID == 1941 || 
                                               x.RID == 229 || 
                                               x.RID == 2101 || 
                                               x.RID == 436 || 
                                               x.RID == 425 || 
                                               x.RID == 2153 || 
                                               x.RID == 2038 || 
                                               x.RID == 206 || 
                                               x.RID == 256 || 
                                               x.RID == 2128 || 
                                               x.RID == 215 ||
                                               x.RID == 1877 ||
                                               x.RID == 1838|| 
                                               x.RID == 1787|| 
                                               x.RID == 1827|| 
                                               x.RID == 78|| 
                                               x.RID == 161|| 
                                               x.RID == 1873|| 
                                               x.RID == 1789|| 
                                               x.RID == 1793|| 
                                               x.RID == 1921|| 
                                               x.RID == 1736|| 
                                               x.RID == 154|| 
                                               x.RID == 188|| 
                                               x.RID == 1814|| 
                                               x.RID == 1900|| 
                                               x.RID == 8|| 
                                               x.RID == 1903|| 
                                               x.RID == 1905|| 
                                               x.RID == 71|| 
                                               x.RID == 1906|| 
                                               x.RID == 1908|| 
                                               x.RID == 1910|| 
                                               x.RID == 1936|| 
                                               x.RID == 102|| 
                                               x.RID == 1914|| 
                                               x.RID == 1797|| 
                                               x.RID == 140|| 
                                               x.RID == 183|| 
                                               x.RID == 142|| 
                                               x.RID == 98|| 
                                               x.RID == 1831|| 
                                               x.RID == 184|| 
                                               x.RID == 105|| 
                                               x.RID == 86|| 
                                               x.RID == 137|| 
                                               x.RID == 200|| 
                                               x.RID == 1933|| 
                                               x.RID == 1875|| 
                                               x.RID == 155|| 
                                               x.RID == 1800|| 
                                               x.RID == 1845
                                               || 
                                               x.RID == 147|| 
                                               x.RID == 1731|| 
                                               x.RID == 1879|| 
                                               x.RID == 23
                                               ?

                                            (
                                              <option value={x.RID}>
                                                {x.Title}
                                              </option>
                                            ):""
                                            )
                                          }
                                        )
                                      : ""
                                    : ""}
                                </select> */}
                              </div>
                            </div>

                            <div className=" form-group modal-form-cs lg:w-1/2 md:w-1/2 w-full ">
                              <label for="">
                                Area of Specialization{" "}
                                <span className="text-red">*</span>
                              </label>
                              <div class="relative w-full right-0 rail-select">
                                <div class="select-side">
                                  {/* <i class="glyphicon glyphicon-menu-down blue"></i> */}
                                  <ChevronDown className="text053C6D" />
                                </div>
                                <Select
                                  options={this.state.optionSpecial}
                                  className="select-dropdown-c fsize15 select-search-ht"
                                  value={this.state.optionSpecialValue}
                                  // defaultValue={this.state.selectedCountryPermanent}
                                  onChange={(e) => this.SpecializationChange(e)}
                                ></Select>
                                {/* <select
                                  required
                                  className="select-dropdown-c fsize15"
                                  value={this.state.SpecializationID}
                                  onChange={(e) => this.SpecializationChange(e)}
                                >
                                  <option value="" disabled>
                                    Select
                                  </option>
                                  {this.props.SPECIALIZATION
                                    ? this.props.SPECIALIZATION.Data
                                      ? this.props.SPECIALIZATION.Data.map(
                                          (x) => {
                                            return (
                                              <option value={x.Value}>
                                                {x.Title}
                                              </option>
                                            );
                                          }
                                        )
                                      : ""
                                    : ""}
                                </select> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="lg:flex md:flex items-center">
                      <div class="form-group modal-form-cs pt-4  lg:w-1/2 md:-1/2 w-full lg:pr-4 md:pr-4">
                        <label for="">
                          Percentage <span className="text-red">*</span>
                        </label>
                        <p className="text-black fsize14 mb-4 font-semibold">
                          (Note: In case of CGPA, please enter only as
                          cumulative percentage as per the conversion formula
                          certified by the degree issuing
                          institution/authority.)
                        </p>
                        <br />
                        <input
                          required
                          type="text"
                          maxLength={2}
                          placeholder=""
                          className=" fsize16"
                          value={this.state.Percentage}
                          onChange={(e) => {
                            // if (e.target.value.length > e.target.maxLength) {
                            //   e.target.value = e.target.value.slice(
                            //     0,
                            //     e.target.maxLength
                            //   );
                            // }
                            this.setState({
                              Percentage: e.target.value.replace(/[^\d]/g, ""),
                            });
                            // this.ValidateNumber(e.target.value);
                            // this.handleChange(e, "Percentage")
                          }}
                        />
                      </div>
                      {/* <span style={{ color: "red" }}>{this.state.errors["Percentage"]}</span> */}
                      {/* <div class="pt-4  lg:w-1/2 md:w-1/2 w-full lg:pl-4 md:pl-4">
                      <div className="flex items-center">
                        <div className="form-group modal-form-cs lg:w-1/2 md:w-1/2 w-full pr-4 ">
                          <label for="">Group 1( Passing Year</label>
                          <DatePicker
                            required
                            selected={this.state.Month}
                            dateFormat="MM"
                            showMonthYearPicker
                            onChange={(date) => this.setState({ Month: date })}
                          />
                        </div>

                        <div className=" form-group modal-form-cs lg:w-1/2 md:w-1/2 w-full lg:pr-0  lg:pt-0 md:pt-0 md:pr-0">
                          <label for="">  and Month)</label>
                          <DatePicker
                            required
                            selected={this.state.Year}
                            showYearPicker
                            dateFormat="yyyy"
                            onChange={(date) => this.setState({ Year: date })}
                          />
                        </div>
                      </div>
                    </div> */}

                      {this.state.EducationGroup != 7 ? (
                        <div className=" lg:flex md:flex  lg:w-1/2 md:w-1/2 w-full lg:pl-4 md:pl-4 ">
                          <div class="form-group modal-form-cs pt-4  lg:w-1/2 md:w-1/2 w-full w-full-reactdrop lg:pr-4 md:pr-4 pr-3.5">
                            <label for="">
                              Passing Month <span className="text-red">*</span>
                            </label>
                            {/* <select name="month" className="info-inputdetail cust-bgwhite"
                                value={this.state.Month}
                                onChange={(e) => {
                                  this.setState({ Month: e.target.value })                    
                                }}
                                >
                                {monthData.map((e, key) => {
                                  return <option key={key} value={e.value}>{e.name}</option>;
                                    })}
                                  </select> */}
                            <DatePicker
                              renderCustomHeader={({
                                date,
                                changeYear,
                                changeMonth,
                                decreaseMonth,
                                increaseMonth,
                                prevMonthButtonDisabled,
                                nextMonthButtonDisabled,
                              }) => (
                                <>
                                  {/* <select
                        value={getYear(date)}
                        onChange={({ target: { value } }) =>
                          changeYear(value)
                        }
                      >
                        {years.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select> */}

                                  {/* <select
                        value={months[getMonth(date)]}
                        onChange={({ target: { value } }) =>
                          changeMonth(months.indexOf(value))
                        }
                      >
                        {months.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select> */}
                                </>
                              )}
                              required
                              selected={this.state.Month}
                              dateFormat="MMMM"
                              showMonthYearPicker
                              onChange={(date) => {
                                this.setState({ Month: date });
                                // this.handleChange(date, "Month")
                              }}
                            />
                            {/* <span style={{ color: "red" }}>{this.state.errors["Month"]}</span> */}
                          </div>
                          <div class="form-group modal-form-cs pt-4  w-full-reactdrop lg:w-1/2 md:w-1/2 w-full  ">
                            <label for="">
                              Passing Year <span className="text-red">*</span>
                            </label>
                            <DatePicker
                              required
                              selected={this.state.Year}
                              maxDate={new Date(lastDateOfYear)}
                              showYearPicker
                              dateFormat="yyyy"
                              onChange={(date) => {
                                this.setState({ Year: date });
                                // this.handleChange(date, "Year")
                              }}
                            />
                            {/* <span style={{ color: "red" }}>{this.state.errors["Year"]}</span> */}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      {this.state.EducationGroup == 7 ? (
                        <div className=" lg:flex md:flex lg:w-1/2 md:w-1/2 w-full lg:pl-4 md:pl-4 ">
                          <div class="form-group modal-form-cs pt-4  lg:w-1/2 md:w-1/2 w-full w-full-reactdrop lg:pr-4 md:pr-4 ">
                            <label for="">
                              Group 1(Month of Passing){" "}
                              <span className="text-red">*</span>
                            </label>

                            {/* <select name="month" className="info-inputdetail cust-bgwhite"
                                value={this.state.Month}
                                onChange={(e) => {
                                  this.setState({ Month: e.target.value })                    
                                }}
                                >
                                {monthData.map((e, key) => {
                                  return <option key={key} value={e.value}>{e.name}</option>;
                                    })}
                                  </select> */}

                            <DatePicker
                              renderCustomHeader={({
                                date,
                                changeYear,
                                changeMonth,
                                decreaseMonth,
                                increaseMonth,
                                prevMonthButtonDisabled,
                                nextMonthButtonDisabled,
                              }) => (
                                <>
                                  {/* <select
      value={getYear(date)}
      onChange={({ target: { value } }) =>
        changeYear(value)
      }
    >
      {years.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select> */}

                                  {/* <select
      value={months[getMonth(date)]}
      onChange={({ target: { value } }) =>
        changeMonth(months.indexOf(value))
      }
    >
      {months.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select> */}
                                </>
                              )}
                              required
                              selected={this.state.Month}
                              dateFormat="MMMM"
                              showMonthYearPicker
                              onChange={(date) => {
                                this.setState({ Month: date });
                                // this.handleChange(date, "Month")
                              }}
                            />

                            {/* <DatePicker
                            required
                            selected={this.state.Month}
                            dateFormat="MM"
                            showMonthYearPicker
                            onChange={(date) => this.setState({ Month: date })}
                          /> */}
                          </div>
                          <div class="form-group modal-form-cs pt-4  w-full-reactdrop lg:w-1/2 md:w-1/2 w-full  ">
                            <label for="">
                              Group 1(Year of Passing){" "}
                              <span className="text-red">*</span>
                            </label>
                            <DatePicker
                              required
                              maxDate={new Date(lastDateOfYear)}
                              selected={this.state.Year}
                              showYearPicker
                              dateFormat="yyyy"
                              onChange={(date) => this.setState({ Year: date })}
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    {/* <div>
                  <a href="#" class="firstattempt-btn">Link Button</a>
                  </div> */}

                    {this.state.EducationGroup == 1 ||
                    this.state.EducationGroup == 8 ? (
                      <div className="flex items-center">
                        <div class="form-group modal-form-cs pt-4  lg:w-1/2 md:w-1/2 w-full lg:pr-4 md:pr-4 ">
                          <label for="">
                            Type <span className="text-red">*</span>
                          </label>
                          <div class="relative w-full right-0 rail-select">
                            <div class="select-side">
                              {/* <i class="glyphicon glyphicon-menu-down blue"></i> */}
                              <ChevronDown className="text053C6D" />
                            </div>
                            <select
                              className="select-dropdown-c fsize15"
                              value={this.state.EducationType}
                              required
                              onChange={(e) =>
                                this.setState({ EducationType: e.target.value })
                              }
                            >
                              <option selected="selected" value="" disabled>
                                Select
                              </option>
                              <option value="1">Full Time</option>
                              <option value="2">Part Time</option>
                              <option value="3">Distance Learning</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {this.state.EducationGroup == 7 ? (
                      <div className="lg:flex md:flex  items-center">
                        {/* <group 1 n 2 > */}
                        <div class="form-group modal-form-cs pt-4  lg:w-1/2 md:w-1/2 w-full ">
                          <label for="">
                            Group 2 Same As Group 1{" "}
                            <span className="text-red">*</span>
                          </label>
                          <div className="flex items-center">
                            <div>
                              <input
                                required
                                id="radio-1"
                                class="radio-custom"
                                name="radio-group"
                                type="radio"
                                value="0"
                                checked={this.state.HasAttempts == "0"}
                                onChange={(e) =>
                                  this.setState({ HasAttempts: e.target.value })
                                }
                              />

                              <label
                                for="radio-1"
                                class="radio-custom-label fsize16 text-black font-normal"
                              >
                                {" "}
                                Yes
                              </label>
                            </div>
                            <div className="ml-6">
                              <input
                                // required
                                id="radio-2"
                                class="radio-custom"
                                name="radio-group"
                                type="radio"
                                value="1"
                                checked={this.state.HasAttempts == "1"}
                                onChange={(e) =>
                                  this.setState({ HasAttempts: e.target.value })
                                }
                              />

                              <label
                                for="radio-2"
                                class="radio-custom-label fsize16 text-black font-normal"
                              >
                                No
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="lg:flex md:flex lg:w-1/2 md:w-1/2 w-full lg:pl-4 md:pl-4">
                          {this.state.HasAttempts == 1 ? (
                            <div class="form-group modal-form-cs pt-4  lg:w-1/2 md:w-1/2 w-full items-center w-full-reactdrop lg:pr-4 md:pr-4 ">
                              <label for="">
                                Group 2(Month of Passing){" "}
                                <span className="text-red">*</span>
                              </label>
                              {/* <select name="month" className="info-inputdetail cust-bgwhite"
                                value={this.state.Month}
                                onChange={(e) => {
                                  this.setState({ Month: e.target.value })                    
                                }}
                                >
                                {monthData.map((e, key) => {
                                  return <option key={key} value={e.value}>{e.name}</option>;
                                    })}
                                  </select> */}

                              <DatePicker
                                required
                                selected={this.state.Grp2Month}
                                dateFormat="MMMM"
                                showMonthYearPicker
                                onChange={(date) =>
                                  this.setState({ Grp2Month: date })
                                }
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.HasAttempts == 1 ? (
                            <div class="form-group modal-form-cs pt-4  lg:w-1/2 md:w-1/2 w-full  w-full-reactdrop">
                              <label for="">
                                Group 2(Year of Passing){" "}
                                <span className="text-red">*</span>
                              </label>
                              <DatePicker
                                required
                                selected={this.state.Grp2Year}
                                showYearPicker
                                dateFormat="yyyy"
                                onChange={(date) =>
                                  this.setState({ Grp2Year: date })
                                }
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="text-right sm-flex lg:mt-44  md:mt-44 mt-6 justify-end">
                  <button
                    className="btn-outline mr-3 btn-width-sm"
                    onClick={() => {
                      this.setState({
                        isAddEducation: !this.state.isAddEducation,
                      });
                      this.emptyStatecancel();
                    }}
                  >
                    CANCEL
                  </button>
                  <button
                    className="btn-filled btn-width-sm ml-3"
                    // onClick={() => this.SaveAcademicDetails()}
                  >
                    SAVE
                  </button>
                </div>
              </div>
            </form>
          )}
        </div>
      </card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    Profile: state.Profile.home.SINGLEAPPLICANTINFO,
    EDUCATIONDETAILS: state.userWalkthrough.info.EDUCATIONDETAILS,
    EDUCATIONGROUP: state.master.info.EDUCATIONGROUP,
    UNIVERSITYMASTER: state.master.info.UNIVERSITYMASTER,
    DEGREEMASTER: state.master.info.DEGREEMASTER,
    COLLEGEMASTER: state.master.info.COLLEGEMASTER,
    SPECIALIZATION: state.master.info.SPECIALIZATION,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getEducationAction: async (payload) =>
      await dispatch(getEducationAction(payload)),
    setEducationAction: async (payload) =>
      await dispatch(setEducationAction(payload)),
    getEDUCATIONGROUPMASTERAction: async (payload) =>
      await dispatch(getEDUCATIONGROUPMASTERAction(payload)),
    getUNIVERSITYMASTERAction: async (payload) =>
      await dispatch(getUNIVERSITYMASTERAction(payload)),
    getSPECIALIZATIONMASTERAction: async (payload) =>
      await dispatch(getSPECIALIZATIONMASTERAction(payload)),
    getCOLLEGEMASTERAction: async (payload) =>
      await dispatch(getCOLLEGEMASTERAction(payload)),
    getDEGREEMASTERAction: async (payload) =>
      await dispatch(getDEGREEMASTERAction(payload)),

    //  getCITYMASTERAction: async (payload) => await dispatch(getCITYMASTERAction(payload)),
    //  setContactAction:async (payload) => await dispatch(setContactAction(payload)),
    // getlanguageAction: async (payload) => await dispatch(getlanguageAction(payload))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Education);
